import allUsers from '@/store/modules/all-users/all-users'
import allUsersEdit from '@/store/modules/all-users/all-users-edit'
import allUsersCreate from '@/store/modules/all-users/all-users-create'
import allUsersDelete from '@/store/modules/all-users/all-users-delete'
import allUsersAthletes from '@/store/modules/all-users/all-users-athletes'
import allUsersParents from '@/store/modules/all-users/all-users-parents'

export default {
  allUsers,
  allUsersEdit,
  allUsersCreate,
  allUsersDelete,
  allUsersAthletes,
  allUsersParents,
}
